/* eslint-disable @typescript-eslint/no-unused-vars */
import { paginationStyle } from '@bingads-webui-campaign-react/common-styles';
import { merge } from '@bingads-webui/primitive-utilities';

export const footerStyle = ({ palette = {} }) => ({
  '& .footer': {
    '& .noborder': {
      '& .flex-cell': {
        borderBottom: 'none',
        borderTop: 'none',
        borderRight: 'none',
      },
    },
    '& .pagination-row .flex-cell': {
      paddingLeft: 0,
      width: '100% !important',
    },

    ...merge(paginationStyle({ palette }), {
      '& .pagination-control': {
        fontSize: 14,
        '&.form-inline > .text': {
          display: 'inline-block',
          padding: 0,
          verticalAlign: 'middle',
        },
        '& .text': {
          display: 'inline-block',
          width: 'auto',
          verticalAlign: 'middle',
        },
      },
    }),
  },
});
